defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Components/ChooseWeeks',
  [
    'Shared/Framework/Mithril/Scripts/Core/Component',
    'DanskeSpil/Framework/NumberGames/Scripts/Helpers/Params',
    'DanskeSpil/Domain/Lotto/Scripts/Helpers/LottoInfo',
    'DanskeSpil/Domain/VikingLotto/Scripts/Helpers/VikingLottoInfo',
    'DanskeSpil/Domain/Eurojackpot/Scripts/Helpers/EurojackpotInfo',
    'DanskeSpil/Domain/PlayTogether/Scripts/Helpers/Dictionary',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/PurchaseFlow/ChooseWeeks',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/Card/CardFlowHeader',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Clubs/ClubPage'
  ],
  function (Component, Params, LottoInfo, VikingLottoInfo, EurojackpotInfo, PlayTogetherDictionary, ChooseWeeks, CardFlowHeader, ClubPage) {

    // Component:
    Component('choose-weeks', [LottoInfo, VikingLottoInfo, EurojackpotInfo, PlayTogetherDictionary], function (m, route, settings, property) {

      // Components:
      var root = {
        controller: function () {
          this.settings = settings;
          this.property = property;
          this.rootDictionary = PlayTogetherDictionary;
          this.dictionary = this.rootDictionary.get.bind({ prefix: 'ChooseWeeks/' });
          this.gameInstanceId = Params.extract('gameInstanceId');
        },

        view: function (controller) {
          return m(ClubPage, { controller: controller }, {
            flowHeader: CardFlowHeader({
              goBack: () => {
                let backUrl = settings.navigation.createPlayChooseRowsPage
                              + '?gameType=' + controller.property('clubPageController').gameType?.()?.toLowerCase()
                              + '&klubId=' + controller.property('clubPageController').clubId();
                if (controller.gameInstanceId) {
                  backUrl += '&gameInstanceId=' + controller.gameInstanceId;
                }
                location.href = backUrl;
              }
            }),
            title: controller.dictionary('PageTitle'),
            content: ChooseWeeks,
            hideTopButtons: true,
          });
        }
      };

      // Routes:
      route('/', root);
    });

  });
